import React, { Component } from 'react'

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = { drawerOpen: false, langOpen: false };
  }

  toggleDrawer = () => {
    this.setState(prev => ({ drawerOpen: !prev.drawerOpen }));
  }

  closeDrawer = () => {
    this.setState({ drawerOpen: false });
  }

  toggleLang = () => {
    this.setState(prev => ({ langOpen: !prev.langOpen }));
  }

  closeLang = () => {
    this.setState({ langOpen: false });
  }

  render() {
    const { drawerOpen, langOpen } = this.state;
    return (
      <>
        <header className="vt-header">
          <div className="vt-shell vt-header-inner">
            <a className="brand" href="#page-top">
              <img src="img/logo.png" alt="Fetchy" />
              <span className="wm">Fetchy</span>
            </a>
            <nav>
              <a href="#how-it-works">Comment ça marche</a>
              <a href="#mission">La science</a>
              <a href="#pricing">Tarifs</a>
              <a href="#faq">FAQ</a>
              <a href="#team">Le bestiaire</a>
            </nav>
            <div className="right" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              {/* Language switcher */}
              <div className="langsw" style={{ position: 'relative' }}>
                <button className="langsw__btn" onClick={this.toggleLang} aria-label="Langue">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/><line x1="2" x2="22" y1="12" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                  </svg>
                  <span>FR</span>
                </button>
                {langOpen && (
                  <>
                    <div style={{ position: 'fixed', inset: 0, zIndex: 99 }} onClick={this.closeLang} />
                    <div className="langsw__drop">
                      <div className="langsw__opt langsw__opt--active">
                        <span>Français</span>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                      </div>
                      <div className="langsw__opt langsw__opt--disabled">
                        <span>English — Bientôt</span>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <a className="vt-btn vt-btn-call" href="https://app.fetchy.vet">Essayer Fetchy</a>
              <button className="vt-mobile-burger" onClick={this.toggleDrawer} aria-label="Menu">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="18" y2="18"/>
                </svg>
              </button>
            </div>
          </div>
        </header>

        {/* Mobile drawer */}
        <div className={`vt-mobile-drawer-overlay${drawerOpen ? ' open' : ''}`} onClick={this.closeDrawer} />
        <div className={`vt-mobile-drawer${drawerOpen ? ' open' : ''}`}>
          <div className="head">
            <span style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 22 }}>Fetchy</span>
            <button onClick={this.closeDrawer} style={{ background: 'var(--neutral-100)', border: 0, borderRadius: 99, width: 36, height: 36, cursor: 'pointer', display: 'grid', placeItems: 'center' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" x2="6" y1="6" y2="18"/><line x1="6" x2="18" y1="6" y2="18"/>
              </svg>
            </button>
          </div>
          <a href="#how-it-works" onClick={this.closeDrawer}>Comment ça marche</a>
          <a href="#mission" onClick={this.closeDrawer}>La science</a>
          <a href="#pricing" onClick={this.closeDrawer}>Tarifs</a>
          <a href="#faq" onClick={this.closeDrawer}>FAQ</a>
          <a href="#team" onClick={this.closeDrawer}>Le bestiaire</a>
          <div style={{ marginTop: 24, display: 'flex', flexDirection: 'column', gap: 10 }}>
            <a className="vt-btn vt-btn-call w100" href="https://app.fetchy.vet">Essayer Fetchy</a>
          </div>
        </div>
      </>
    )
  }
}

export default Navigation;
